// Live-Diktat über die Web Speech API (nativ im Browser, gratis, kein Server).
// Wörter erscheinen WÄHREND des Sprechens — das ist die klassische
// "Diktierfunktion" (im Gegensatz zu Aufnahme → Transkription als Block).
// Auf macOS/iOS Safari nutzt das die Apple-Diktat-Engine, in Chrome die von
// Google. Audio verlässt das System genauso wie beim Tastatur-Diktat des
// Betriebssystems. Browser ohne Unterstützung: dictationSupported() === false,
// dann nutzt der Aufrufer den Aufnahme→Whisper-Fallback.

export function dictationSupported() {
  if (typeof window === 'undefined') return false
  // Brave exponiert zwar webkitSpeechRecognition (Chromium-Basis), hat die
  // eigentliche Spracherkennung aber entfernt — der Konstruktor startet, liefert
  // jedoch nie Ergebnisse und der Knopf bleibt scheinbar hängen. Daher Brave als
  // "nicht unterstützt" behandeln, damit der Aufrufer sauber auf den
  // Aufnahme→Whisper-Fallback geht. (navigator.brave existiert nur in Brave.)
  if (navigator.brave) return false
  return !!(window.SpeechRecognition || window.webkitSpeechRecognition)
}

/**
 * Startet ein Live-Diktat. Ruft onText(volltext) bei jedem (Zwischen-)Ergebnis,
 * onEnd() beim natürlichen Ende und onError(event) bei Fehlern.
 * `base` = bereits im Feld stehender Text, der erhalten bleibt.
 * Gibt ein Handle mit stop() zurück, oder null wenn nicht unterstützt.
 */
export function createDictation({ lang = 'de-CH', base = '', onText, onEnd, onError } = {}) {
  const SR = (typeof window !== 'undefined') && (window.SpeechRecognition || window.webkitSpeechRecognition)
  if (!SR) return null

  const recognition = new SR()
  recognition.lang = lang
  recognition.continuous = true
  recognition.interimResults = true

  const prefix = base ? base.replace(/\s*$/, '') + ' ' : ''

  recognition.onresult = (event) => {
    let finalText = ''
    let interim = ''
    for (let i = 0; i < event.results.length; i++) {
      const r = event.results[i]
      if (r.isFinal) finalText += r[0].transcript
      else interim += r[0].transcript
    }
    onText?.(prefix + finalText + interim)
  }
  recognition.onerror = (e) => onError?.(e)
  recognition.onend = () => onEnd?.()

  let stopped = false
  try {
    recognition.start()
  } catch (err) {
    onError?.(err)
    return null
  }

  return {
    stop() {
      if (stopped) return
      stopped = true
      try { recognition.stop() } catch { /* ignore */ }
    }
  }
}
